<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI"
import Pagination from "@/components/standard/preventionbrigade/preventionbrigadePagination";
import Swal from "sweetalert2";
import { sendNotification } from "@/utils/helpers/notification"
import CheckModal from "@/components/CheckModal"
import { dateFormat } from "@/utils/helpers/format";
import ItemAPI from "@/services/items/itemsAPI";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import sgsstResponsibilitiesAPI from "@/services/standards/sgsst-responsibilities/sgsstResponsibilitiesAPI";
import DocumentActions from "@/components/document/DocumentActions.vue";
import newScoresAPI from "@/services/newScores/newScoresAPI";
import itemFormatsAPI from "@/services/itemFormats/itemFormatsAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Responsabilidades en el SG SST",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
    CheckModal,
    Pagination,
    DocumentActions,
  },
  computed: {
    isSigned() {
      return this.sgsstResponsibilities.workflow_status === 'signed'
    },
    sgsstResponsibilitiesAPI() {
      return sgsstResponsibilitiesAPI
    },
  },
  data() {

    return {
      title: "1.1.2 Responsabilidades en el SG SST",
      items: [
        {
          text: "Estandares",
          href: "/forms/estandares",
        },
        {
          text: "Responsabilidades en el SG SST",
          active: true,
        },
      ],

      lista: [],
      file: null,
      loading: true,
      item: null,
      itemStatus: null,
      company: "",
      itemData: null,
      guardando: false,

      preventionbrigade: {
        file: "datos",
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      sgsstResponsibilities: {
        resp_link: null,
        resp_word: "askhfbashfjhasfjhvasjfhvas",
        resp_rol: null,
        employee_id: null,
      },

      usersList: null,
      company: this.$store.getters["company/getCompany"] || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,
    };
  },
  methods: {

    getItemData() {
      ItemAPI.getItems(2)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getFile(file) {
      const name = file.split('/')
      return name[name.length - 1]
    },

    allowAccess() {
      try {
        const item = this.itemData;
        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"].company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    goPage(page) {
      window.location.href = page
    },

    fetch() {
      this.$refs.paginator.query();
    },

    dateConvert(date) {
      return dateFormat(date);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 2)
        .then(response => {
          this.item = response || null
          this.itemStatus = response.status ? response.status : null
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
        * Method to know the status item.
        * @param {Number} - Item ID.
        * @param {Object} - Item to get.
        * @param {Number} -  Status item.
        */
    getStatusItem(ID, item, itemStatus) {
      CompanyItemsAPI.getStatus(this.companyID, ID)
        .then(response => {
          item = response || null
          itemStatus = response.status
        })
        .catch(error => {
          console.log(error)
        })
    },

    /**
         * This method is used to send notification to SST user and SST company.
         * The sendNotification method import is required.
         * @param {Number} messageID - The message ID that will be associated to notification.
         * @param {Number} itemID - The item ID that will be associated to notification.
         * @param {Boolean} user - The user that will e associated to notification.
         * @return {Boolean} True if the notification is sent, false if not.
         */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
    * This method is used to knows if the user has the permission indicated
    * @param {String} name The name of the permission
    * @param {Array} roles the roles that permitted to access the action 
    * @returns {Boolean} true if the user has the permission indicated or false if no
    */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role ? this.$store.state.auth.info.role : null
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role = role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions
        // Know if the user has the permission indicated
        const enabled = permissions.find(permission => permission.name === name)
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false
      } // Close else the user is not logged
    },

    /**
   * This method is used to redirect to the page indicated
   * @param {String} page The page to redirect
   */
    goPage(page) {
      window.location.href = page
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.sgsstResponsibilities.resp_link)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.company.nit}/1.1.2/${this.sgsstResponsibilities.employee_id}/${name}`;
        } else {
          url = `sst-prod/${this.company.nit}/1.1.2/${this.sgsstResponsibilities.employee_id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.sgsstResponsibilities.resp_link = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getList() {
      sgsstResponsibilitiesAPI.getAllResponsabilities(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          this.loading = false
          let responsabilidad = response.employees.data;
          this.lista = responsabilidad
        })
        .catch((error) => {
          console.log(error);
          this.loading = false
        });
    },

    async update() {
      this.guardando = true
      this.loading1 = true
      let document = await this.uploadDocument();
      if (document) {
        sgsstResponsibilitiesAPI.update(this.$route.params.id, {
          resp_link: this.sgsstResponsibilities.resp_link,
          resp_word: this.sgsstResponsibilities.resp_word,
          resp_rol: this.sgsstResponsibilities.resp_rol,
          employee_id: this.sgsstResponsibilities.employee_id,
        })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 2,
              status: 'Pendiente',
            }
            newScoresAPI.calculateScores(itemChange)
              .then(response => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Se ha actualizado con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }, 1000)
                this.$router.go(-1);
              })
              .catch(error => {
                console.log(error)
              })
          })
          .catch((error) => {
            console.log(error);
            this.loading1 = false
          });
      } else {
        this.loading1 = false
        setTimeout(() => {
          Swal.fire({
            title: "¡Error!",
            text: "¡No se ha podido actualizar!",
            type: "error",
            icon: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
          window.location.reload()
        }, 3000)
      }
    },

    getResponsabilities() {
      sgsstResponsibilitiesAPI.getResponsabilities(this.$route.params.id)
        .then((response) => {
          this.loading = false
          this.sgsstResponsibilities = {
            id: response.sgsstResp.id,
            resp_link: response.sgsstResp.resp_link,
            resp_word: response.sgsstResp.resp_word,
            resp_rol: response.sgsstResp.resp_rol,
            employee_id: response.sgsstResp.employee_id,
            workflow_status: response.sgsstResp.workflow_status || 'draft',
            signed_at: response.sgsstResp.signed_at,
          };
        })
        .catch((error) => {
          console.log(error);
        });
    },

    onDocumentSigned(payload) {
      this.sgsstResponsibilities = {
        ...this.sgsstResponsibilities,
        workflow_status: payload.workflow_status,
        signed_at: payload.signed_at,
      }
    },

    async print() {
      try {
        const res = await itemFormatsAPI.list('1.1.2')
        const f = ((res && res.data) || []).find(x => x.label === 'Formato individual')
        if (f) window.location.href = itemFormatsAPI.url(f.bucket_key)
      } catch (error) {
        console.log(error);
      }
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getUsers() {
      CompanyAPI.getCompany(this.$store.getters["company/getCompany"].id || null)
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id)
            .then((res) => {
              this.usersList = res.employee
            })
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  mounted() {
    this.getResponsabilities()
    this.getItems()
    this.getItemData();
    this.getUsers();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-9">
        <div class="col-xl-12" v-if="!loading && classificationID <= 4">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                </div>
                <div class="col-6 text-right m-b-0">
                  <button :disabled="!allowAccess()" @click="print" class="btn btn-primary mx-1" id="tooltip">
                    <span class="btn-label"> <i class="bx bx-download"></i></span> Descargar
                  </button>
                  <b-tooltip target="tooltip" placement="left">
                    Descargar roles y responsabilidades SG-SST
                  </b-tooltip>
                </div>
              </div>
              <div class="row">
                <div class="col-6">
                </div>
              </div>
              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">
                  <b-form-group label-for="employee" class="col-md-6 px-2" label="Colaborador">
                    <select :disabled="!getRole('Crear') || !allowAccess()" required
                      v-model="sgsstResponsibilities.employee_id" class="form-control">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group label-for="number" class="col-md-6 px-2" label="Roles en el SG-SST">
                    <select id="type" class="form-control" v-model="sgsstResponsibilities.resp_rol">
                      <b-form-select-option value="Management">
                        Nivel Gerencial
                      </b-form-select-option>
                      <b-form-select-option value="Media">
                        Mandos medios
                      </b-form-select-option>
                      <b-form-select-option value="Colaborators">
                        Colaboradores
                      </b-form-select-option>
                      <b-form-select-option value="Sgsst">
                        Responsable del SG-SST
                      </b-form-select-option>
                      <b-form-select-option value="Copasst">
                        Comité Paritario de Seguridad y Salud en el Trabajo
                      </b-form-select-option>
                      <b-form-select-option value="Cocola">
                        Comité de Convivencia Laboral
                      </b-form-select-option>
                      <b-form-select-option value="Brigade">
                        Brigadista
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-12 px-2" label="Subir roles y responsabilidades" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar"
                      :placeholder="sgsstResponsibilities.resp_link ? getFile(sgsstResponsibilities.resp_link) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..." v-model="file" @change="uploadFile"
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      v-on:change="uploadFile">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <div v-if="isSigned" class="alert alert-success py-2 mb-2 small">
                    🔒 Este documento ya fue firmado y está bloqueado para edición.
                  </div>
                  <button :disabled="guardando || isSigned" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>

        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>

      <div class="col-md-3" v-if="!loading && sgsstResponsibilities.id && companyID">
        <DocumentActions
          :document-id="sgsstResponsibilities.id"
          :company-id="companyID"
          :workflow-status="sgsstResponsibilities.workflow_status || 'draft'"
          :signed-at="sgsstResponsibilities.signed_at"
          :api-service="sgsstResponsibilitiesAPI"
          document-title="Responsabilidades en SG-SST"
          signer-role="gerente"
          @signed="onDocumentSigned"
        />
      </div>
    </div>
  </Layout>
</template>

<style scoped>
.background-modal {
  background-color: transparent !important;
  border: none;
}
</style>